import { FormType } from "@simplyk/common";

import { useLiveFormEditorContext } from "../../common/LiveFormEditorContext";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { ReceiptPDFPreview } from "@/components/PDFPreview/ReceiptPDFPreview";

export const TaxReceiptLivePreview = () => {
  const { liveFormData } = useLiveFormEditorContext<"donation-form">();
  const { locale } = useLocaleContext();

  if (!liveFormData?.donation?.hasReceipt) {
    return null;
  }

  return (
    <ReceiptPDFPreview locale={locale} formType={FormType.DonationForm} formColor={liveFormData?.donation?.color} />
  );
};
